import { cn } from "@/lib/utils"

interface ReadOnlyFormFieldProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string
  dataTestId?: string
}

const ReadOnlyFormField = ({ className, children, label, dataTestId }: ReadOnlyFormFieldProps) => {
  return (
    <div data-testid={dataTestId} className={cn("grid gap-0.5", className)}>
      <div
        data-testid={`${dataTestId}-label`}
        className="text-on-surface-subdued text-xs font-normal tracking-[0.25px]">
        {label}
      </div>
      <div data-testid={`${dataTestId}-value`} className="text-on-surface text-sm">
        {children}
      </div>
    </div>
  )
}

export { ReadOnlyFormField }
